import { Team__UTPaquime } from "./teams/UTPaquime";
import { Team__Potras } from "./teams/Potras";
import { Team__Cerveceras } from "./teams/Cerveceras";
import { Team__Omega } from "./teams/Omega";
import { Team__Abejas } from "./teams/Abejas";

const GroupA = [
  Team__UTPaquime,
  Team__Potras,
  Team__Cerveceras,
  Team__Omega,
  Team__Abejas,
];

export const Groups_2026_Womens = [GroupA];
